import { render, staticRenderFns } from "./PolymerDetails.vue?vue&type=template&id=4c5b0683&"
import script from "./PolymerDetails.vue?vue&type=script&lang=js&"
export * from "./PolymerDetails.vue?vue&type=script&lang=js&"
import style0 from "./PolymerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports